import { SearchInputHandle } from "../../../../components/Tables/TableCustomeHandle/TableCustomeHandle.tsx";

export default function Header() {
  return (
    <div className="flex min-h-[80px] sm:min-h-[100px] flex-col justify-end pt-3 pb-1 sticky px-2 sm:px-0">
      <div className="flex flex-col lg:flex-row gap-2 sm:gap-x-2 mb-4 lg:items-end">
        <div className="flex flex-col flex-1">
          <h2 className="mb-1 text-lg sm:text-xl lg:text-2xl xl:text-3xl font-extrabold leading-none tracking-tight text-gray-900">
            AI Social Invites
          </h2>
          <p className="text-xs sm:text-sm font-semibold text-gray-600">
            Create and share AI-generated social media invites. Share them on Facebook, X, or copy to clipboard.
          </p>
        </div>
        <div className="flex-1 lg:flex-none flex flex-row h-fit items-center justify-start lg:justify-end gap-x-2 mt-2 lg:mt-0 mb-1 px-1">
          <SearchInputHandle
            placeholder={"Search invites..."}
            eventName={"ai-social-list"}
          />
        </div>
      </div>
    </div>
  );
}